import styled from 'styled-components';

import { baseColor, darkBaseColor, primaryColor, lightPrimaryColor } from 'views/services/color-scheme';
import backgroundImage from './assets/background-image.gif';

export const Background = styled.div`
  background-image: url(${backgroundImage});
  background-position: center top;
  height: 1273px;
`;

export const Heading = styled.div`
  position: absolute;
  left: 47px;
  top: 42px;
`;

export const List = styled.div`
  & > table {
    width: 666px;
    border-collapse: collapse;
    & > thead {
      & > tr {
        & > th {
          padding: 3px 5px;
          border-right: 3px solid ${baseColor};
          border-bottom: 3px solid ${baseColor};
          text-align: center;
          background-color: ${primaryColor};
          color: ${baseColor};
          font-weight: normal;
        }
      }
    }
    & > tbody {
      & > tr {
        & > th, & > td {
          padding: 3px 5px;
          border-right: 3px solid ${baseColor};
          border-bottom: 3px solid ${baseColor};
          &:nth-child(5) {
            text-align: center;
          }
        }
        &:nth-child(odd) {
          background-color: ${lightPrimaryColor};
        }
        &:nth-child(even) {
          background-color: ${darkBaseColor};
        }
      }
    }
  }
`;

export const Thumbnails = styled.div`
  & > p {
    font-size: 80%;
  }
  & > img {
    border: 1px solid ${primaryColor};
    position: relative;
    top: -2px;
  }
`;

export const Machines = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 93px;
  }
  & > ${List} {
    position: absolute;
    left: 44px;
    top: 143px;
  }
  & > ${Thumbnails} {
    position: absolute;
    left: 725px;
    top: 135px;
  }
`;

export const EastFactory = styled.div`
  & > h2 {
    position: absolute;
    left: 62px;
    top: 755px;
  }
  & > img {
    position: absolute;
    left: 44px;
    top: 800px;
  }
  & > p {
    position: absolute;
    left: 44px;
    top: 1233px;
  }
`;

export const CleanRoom = styled.div`
  & > h2 {
    position: absolute;
    left: 502px;
    top: 755px;
  }
  & > img {
    position: absolute;
    left: 484px;
    top: 800px;
  }
  & > p {
    position: absolute;
    left: 484px;
    top: 1233px;
  }
`;
